export const DOCUMENT_TYPES = {
    DNI: "DNI",
    CE: "CE",
};

export const DOCUMENT_TYPES_LABELS = {
    [DOCUMENT_TYPES.DNI]: "DNI",
    // [DOCUMENT_TYPES.CE]: "CE",
};
